/* eslint-disable */
import React, { useEffect, useRef, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { useDataContext } from '../context';
import { jwtDecode } from 'jwt-decode';

const API_URL = import.meta.env.VITE_API_URL;
const TRAINING_API_URL = "https://203.114.108.46:11302/API-BSR/v1"; // แยก URL ของ Training ออกมา

function GetCandidateData() { // เปลี่ยนชื่อให้ตรงกับหน้าที่
  const { data, setData } = useDataContext();
  const [cookies] = useCookies(['session']);
  
  // ตัวกันยิงซ้ำ (แยกกัน 2 ตัวเพราะ Logic ต่างกัน)
  const hasFetchedTraining = useRef(false);
  const hasFetchedCandidate = useRef(false);

  // 1. แปลง Token (ใช้ useMemo)
  const decodedToken = useMemo(() => {
    try {
      return cookies.session ? jwtDecode(cookies.session) : null;
    } catch (e) { return null; }
  }, [cookies.session]);


  // -------------------------------------------------------
  // 2. Logic ดึงข้อมูล Training (BSR Training)
  // -------------------------------------------------------
  useEffect(() => {
    // เงื่อนไขการหยุด:
    if (!decodedToken?.initials) return;
    if (data.getTraininghistory && data.getTraininghistory.length > 0) return; // มีข้อมูลแล้ว
    if (hasFetchedTraining.current) return; // ยิงไปแล้ว

    const fetchTraining = async () => {
      hasFetchedTraining.current = true;
      try {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Basic bGVhcm5pbmdAYm9vbnNpcmkuY29tOlBAc3N3MHJkISEh');

        const requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow',
        };

        const response = await fetch(
          `${TRAINING_API_URL}/getBSRTraining?EmpNo=${decodedToken.initials}`,
          requestOptions
        );
        const result = await response.json();

        setData((prevData) => ({
          ...prevData,
          getTraininghistory: result.results || [],
        }));
      } catch (error) {
        console.error("Error fetching training history:", error);
        hasFetchedTraining.current = false;
      }
    };

    fetchTraining();

  }, [decodedToken?.initials]);


  // -------------------------------------------------------
  // 3. Logic ดึงข้อมูล Candidate (รวม 2 fetch เป็น 1 เดียว)
  // -------------------------------------------------------
  useEffect(() => {
    // เงื่อนไขการหยุด:
    if (!decodedToken?.candidateId) return;
    if (data.getCandidate) return; // มีข้อมูลแล้ว
    if (hasFetchedCandidate.current) return; // ยิงไปแล้ว

    const fetchCandidate = async () => {
      hasFetchedCandidate.current = true;
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
        
        // ยิงครั้งเดียว ได้ข้อมูลครบ
        const response = await fetch(`${API_URL}/getCandidate/${decodedToken.candidateId}`, requestOptions);
        const result = await response.json();
        const candidateData = result.data || {};

        setData((prevData) => ({
          ...prevData,
          getCandidate: candidateData,
          // แตกข้อมูลย่อยออกมาตามที่โค้ดเดิมต้องการ
          workExperience: candidateData.workExperience || [],
          certificationTraining: candidateData.certificationTraining || [],
          languageSkills: candidateData.languageSkills || [],
        }));

      } catch (error) {
        console.error("Error fetching candidate data:", error);
        hasFetchedCandidate.current = false;
      }
    };

    fetchCandidate();

  }, [decodedToken?.candidateId]);

  return null;
}

export default GetCandidateData;